const capitalize = function (lowcase) {
  return lowcase.charAt(0).toUpperCase() + lowcase.slice(1)
}

const capitalizeWords = function (string) {
  return string ? string.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase()
  }) : null
}
const prepositionApostrophe = function (string, lettrePreposition = 'd') {
  const graineCommenceParUneVoyelle = string ? 'aeiouyAEIOUY'.indexOf(string.substring(0, 1)) !== -1 : ''
  const preposition = graineCommenceParUneVoyelle === true ? lettrePreposition + '\'' : lettrePreposition + 'e '
  return preposition + string
}

export default {
  capitalize,
  capitalizeWords,
  prepositionApostrophe
}
